/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PhotoResource } from './';
import {
    PhotoResourceFromJSON,
    PhotoResourceFromJSONTyped,
    PhotoResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientOverviewResource
 */
export interface ClientOverviewResource {
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    organizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResource
     */
    fullName: string;
    /**
     * 
     * @type {PhotoResource}
     * @memberof ClientOverviewResource
     */
    photo?: PhotoResource;
}

/**
 * Check if a given object implements the ClientOverviewResource interface.
 */
export function instanceOfClientOverviewResource(value: object): value is ClientOverviewResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function ClientOverviewResourceFromJSON(json: any): ClientOverviewResource {
    return ClientOverviewResourceFromJSONTyped(json, false);
}

export function ClientOverviewResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOverviewResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'identityId': json['identityId'],
        'fullName': json['fullName'],
        'photo': json['photo'] == null ? undefined : PhotoResourceFromJSON(json['photo']),
    };
}

export function ClientOverviewResourceToJSON(value?: ClientOverviewResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'identityId': value['identityId'],
        'fullName': value['fullName'],
        'photo': PhotoResourceToJSON(value['photo']),
    };
}

